import { WIDGET_VERSION } from "@/constants";
import { WidgetNames } from "@/constants/widget-names";
import { BehaviorSubject, Observable, distinctUntilChanged, map } from "rxjs";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import { WidgetsVersions } from "./types";

class WidgetsVersionsProvider {
    private readonly _widgetsVersions: BehaviorSubject<WidgetsVersions>;

    constructor(logger: LoggerInterface) {
        logger.debug("WidgetsVersionsProvider is initialized");

        this._widgetsVersions = new BehaviorSubject<WidgetsVersions>({});
    }

    selectVersion(widgetName: WidgetNames): Observable<WIDGET_VERSION | null> {
        return this._widgetsVersions.pipe(
            map((versions) => versions[widgetName] || null),
            distinctUntilChanged()
        );
    }

    setVersion(widgetName: WidgetNames, version: WIDGET_VERSION) {
        const currentVersions = this._widgetsVersions.value;
        const updatedVersions = { ...currentVersions, [widgetName]: version };
        this._widgetsVersions.next(updatedVersions);
    }
}

export default WidgetsVersionsProvider;
